import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import escape from '../utils/escape';

import ListItemForTaskInput from './ListItemForTaskInput';

import taskActions from '../actions/taskActionCreators';

require.ensure([], () => {  
    require('./AutoTaskInput.less');
});

//TODO - why this exists?
class AutoTaskInputUsersOverview extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            blurTimeout: null,
            focused: false,
            forcePopup: this.props.forceInitialPopup,
            selectedIndex: 0,
            scrollTop: 0,
            tasks: [],
            text: "",
            width: 0,
        };
    }

    // EVENT HANDLERS

    handleBlur = () => {
        this.setState({
            blurTimeout: setTimeout(() => {
                this.setState({
                    focused: false,
                    selectedIndex: 0,
                    forcePopup: false
                });
            }, 200)
        });
    }

    handleChange = (changeEvent) => {
        let text = changeEvent.target.value;

        this.props.dispatch(taskActions.setSelectedTask(null));
        this.setState({
            focused: true,
            forcePopup: true,
            text: text,
            selectedIndex: 0,
            scrollTop: 0
        });


        if (this.props.handleTextChange)
            this.props.handleTextChange(text);
    }

    handleClick = () => {
        if (this.state.focused) this.setState({ forcePopup: true });
    }

    handleFocus = () => {
        this.setState({
            focused: true,
            selectedIndex: 0
        });
    }

    handleKeyDown = (keyEvent) => {
        let newScrollTop = this.state.scrollTop;

        if (keyEvent.key === "Tab" && !(this.props.disableTab && this.state.selectedIndex == 0 && (!this.state.text || this.state.text.trim() === ''))) {
            this.filterAndSetSelectedTask();
        } else if (keyEvent.key === "ArrowUp" && this.state.selectedIndex - 1 >= 0) {
            // calculate the new position by subtracing height of one item and then set it
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop - ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex - 1)]).scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            this.setState({
                selectedIndex: this.state.selectedIndex - 1,
                focused: true,
                scrollTop: newScrollTop
            });
        } else if (keyEvent.key === "ArrowDown" && this.state.selectedIndex + 1 < this.state.filteredTasks.length) {
            // calculate the new position by adding height of one item but watching that it doesn't go over max height
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop + ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex + 1)]).scrollHeight;
                let popupDOMNode = ReactDOM.findDOMNode(this.refs.popup);
                if (newScrollTop > popupDOMNode.scrollHeight) newScrollTop = popupDOMNode.scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            // filter tasks since we are gonna show the popup list
            let filter = new RegExp(escape.escapeInput(this.state.text), 'i');

            this.setState({
                selectedIndex: this.state.selectedIndex + 1,
                focused: true,
                scrollTop: newScrollTop,
                filteredTasks: this.state.filteredTasks.filter(task => filter.test( task.name) || filter.test(task.projectName) || filter.test(task.alias) )
            });
        } else if (keyEvent.key === "Escape" && this.state.focused) {
            // don't close the create pill outside
            keyEvent.stopPropagation();

            this.setState({
                focused: false,
                forcePopup: false
            });
        }
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            this.filterAndSetSelectedTask();
            // if this would propagate it would close the form outside
            keyEvent.stopPropagation();
        }
    }

    handleMouseDown = (selectedIndex) => { this.setSelectedTask(selectedIndex); }

    handleMouseOver = (selectedIndex) => { this.setState({ selectedIndex: selectedIndex }); }

    handleScroll = () => {
        if (this.state.blurTimeout) {
            clearTimeout(this.state.blurTimeout);
            this.setState({ blurTimeout: null });
            ReactDOM.findDOMNode(this.refs.taskField).focus();
        }
    }

    // OTHER METHODS

    clear = () => {
        this.props.dispatch(taskActions.setSelectedTask(null));
        this.setState({
            filteredTasks: [],
            focused: false,
            forcePopup: false,
            selectedIndex: 0,
            scrollTop: 0,
            text: ""
        }, () => {
            if (this.props.handleTextChange) {
                this.props.handleTextChange(this.state.text);
            }
        });
    }
    
    clearInput = () => {
        this.props.dispatch(taskActions.setSelectedTask(null));
        this.setState({
            filteredTasks: this.state.tasks.filteredTasks,
            focused: false,
            forcePopup: false,
            scrollTop: 0,
            selectedIndex: 0,
            text: ""
        });
    }

    filterAndSetSelectedTask = () => {
        if (this.state.filteredTasks.length === 1) {
            this.setSelectedTask(0);
        } else if (this.state.filteredTasks.length > 1) {
            this.setSelectedTask(this.state.selectedIndex);
        }
    }

    setSelectedTask (selectedIndex) {
        let selectedTask = this.props.tasks[selectedIndex];
        this.props.dispatch(taskActions.setSelectedTask(selectedTask));
        this.setState({ text: selectedTask.name });

        this.props.onSelectCallback(selectedTask);
    }
    
    // RENDER METHOD

    render = () => {
        return (
            <span>
                <input
                    type="text"
                    className="form-control"
                    ref="taskField"
                    value={this.state.text}
                    placeholder={this.props.placeholder}
                    onKeyDown={this.handleKeyDown}
                    onKeyPress={this.handleKeyPress}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onClick={this.handleClick}
                    title={this.state.text.length > 50 ? this.state.text : null}
                    />

                {
                    this.props.enableClear && this.state.text && this.state.text !== ''
                    ? <a style={{"cursor" : "pointer", "paddingRight" : "20px", "marginTop" : "5px"}} onClick={this.clearInput} className="filter-clear">
                        <span><span className="md-clear"/></span>
                      </a>
                    : null
                }

                {
                    this.state.forcePopup && this.props.tasks && this.props.tasks.length > 0
                    ?
                        (
                            <ul className="popup" onScroll={this.handleScroll} style={{ "width": this.state.popupWidth + "px", "top": this.state.popupTop + "px", "left": this.state.popupLeft + "px" }} ref="popup" onClick={this.handleClick}>
                                {
                                    this.props.tasks.map((task, i) => {
                                        let classNames = classnames({
                                            'popup-text': i != this.state.selectedIndex,
                                            'popup-text-selected': i === this.state.selectedIndex
                                        });

                                        return (<ListItemForTaskInput
                                                   classNames={classNames}
                                                   id={task.id + this.state.text}
                                                   index={i}
                                                   key={task.id + this.state.text}
                                                   mouseDown={this.handleMouseDown}
                                                   mouseOver={this.handleMouseOver}
                                                   oneline={this.props.oneline}
                                                   projectName={task.projectName}
                                                   ref={"item" + i}
                                                   taskName={task.name}
                                                   />);
                                    })
                                }
                            </ul>
                        )
                    : null
                }
            </span>
        );
    }
}

AutoTaskInputUsersOverview.propTypes = {
    autoFocus: PropTypes.bool,
    disableTab: PropTypes.bool,
    dispatch: PropTypes.func,
    enableClear: PropTypes.bool,
    focusEvent: PropTypes.bool,
    forceInitialPopup: PropTypes.bool,
    handleTextChange: PropTypes.func,
    hideClosed: PropTypes.bool,
    hideArchived: PropTypes.bool,
    oneline: PropTypes.bool,
    onSelectCallback: PropTypes.func,
    placeholder: PropTypes.string,
    selectedProject: PropTypes.object,
    selectedTask: PropTypes.object,
    tasks: PropTypes.array
};

AutoTaskInputUsersOverview.defaultProps = {
    onSelectCallback () { },
    forceInitialPopup: false,
    oneline: false,
    hideClosed: false
};

const mapStateToProps = (state) => {
    //TODO selectedProject usage is not implemented
    return {
        selectedProject: state.projects.selectedProject,
        selectedTask: state.tasks.selectedTask
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutoTaskInputUsersOverview);


/** WEBPACK FOOTER **
 ** ./src/app/components/AutoTaskInputUsersOverview.js
 **/